import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const resetMultiexecution = async (teststepid) => {
  const userDetail = localStorage.getItem("userDetail");
  if (!userDetail) throw new Error("No user details found in localStorage");
  
  const user = JSON.parse(userDetail);
  
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=resetMultiExecution&tsid=${teststepid}&companyid=${user.companyid}`,
  );
  
  return response.data;
};

const useResetMultiExecution = (teststepid, options = {}) => {
  return useMutation({
    mutationFn: () => resetMultiexecution(teststepid),
    ...options,
  });
};

export default useResetMultiExecution;